/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n1CardBody.vue?vue&type=template&id=0d76bfae&scoped=true"
import script from "./n1CardBody.vue?vue&type=script&lang=js"
export * from "./n1CardBody.vue?vue&type=script&lang=js"
import style0 from "./n1CardBody.vue?vue&type=style&index=0&id=0d76bfae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76bfae",
  null
  
)

export default component.exports